import { render } from "./reservationsComponent.vue?vue&type=template&id=03fcc7ab&scoped=true"
import script from "./reservationsComponent.vue?vue&type=script&lang=js"
export * from "./reservationsComponent.vue?vue&type=script&lang=js"

import "./reservationsComponent.vue?vue&type=style&index=0&id=03fcc7ab&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fcc7ab"]])

export default __exports__